import initialState from './initialState';
import { reducer as fetchModelDataReducer } from './fetchModelData';
import { reducer as setFilterReducer } from './setFilter';
import { reducer as setAssignmentFormOpenReducer } from './setAssignmentFormOpen';
import { reducer as changeAssignmentReducer } from './changeAssignment';
import { reducer as saveScheduleReducer } from './saveSchedule';
import { reducer as optimizeScheduleReducer } from './optimizeSchedule';
import { reducer as clearScheduleReducer } from './clearSchedule';
import { reducer as startSchedulingReducer } from './startScheduling';
import { reducer as readSchedulingResultReducer } from './readSchedulingResult';
import { reducer as setScatterChartAxisReducer } from './setScatterChartAxis';
import { reducer as setUploadModeReducer } from './setUploadMode';
import { reducer as publishAssignmentsReducer } from './publishAssignments';
import { reducer as updatePlanReducer } from './updatePlan';
import { reducer as savePlansReducer } from './savePlans';
import { reducer as createSeasonReducer } from './createSeason';
import { reducer as deleteSeasonReducer } from './deleteSeason';
import { reducer as syncPlansWithPcoReducer } from './syncPlansWithPco';
import { reducer as dismissSyncPlansWithPcoMessagesReducer } from './dismissSyncPlansWithPcoMessages';
import { reducer as saveSeasonReducer } from './saveSeason';
import { reducer as setCurrentSeasonReducer } from './setCurrentSeason';
import { reducer as setSelectedScheduleReducer } from './setSelectedSchedule';
import { reducer as fetchScheduleReducer } from './fetchSchedule';
import { reducer as syncWorkersWithPcoReducer } from './syncWorkersWithPco';
import { reducer as fetchMissingPropertiesReducer } from './fetchMissingProperties';
import { reducer as createScheduleReducer } from './createSchedule';
import { reducer as fetchEmailReducer } from './fetchEmail';

const reducers = [
  fetchModelDataReducer,
  setFilterReducer,
  setAssignmentFormOpenReducer,
  changeAssignmentReducer,
  saveScheduleReducer,
  optimizeScheduleReducer,
  clearScheduleReducer,
  startSchedulingReducer,
  readSchedulingResultReducer,
  setScatterChartAxisReducer,
  setUploadModeReducer,
  publishAssignmentsReducer,
  updatePlanReducer,
  savePlansReducer,
  createSeasonReducer,
  deleteSeasonReducer,
  syncPlansWithPcoReducer,
  dismissSyncPlansWithPcoMessagesReducer,
  saveSeasonReducer,
  setCurrentSeasonReducer,
  setSelectedScheduleReducer,
  fetchScheduleReducer,
  syncWorkersWithPcoReducer,
  fetchMissingPropertiesReducer,
  createScheduleReducer,
  fetchEmailReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  /* istanbul ignore next */
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/home/redux/reducer.js